import { render, staticRenderFns } from "./PageDataTable.vue?vue&type=template&id=4d9ed34e&"
import script from "./PageDataTable.vue?vue&type=script&lang=js&"
export * from "./PageDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports